import { EditPageRecommendationsData } from '../../typings/recommendations';

export const UPDATE_RECOMMENDATIONS_FOR_BANNERS_EDIT =
    'UPDATE_RECOMMENDATIONS_FOR_BANNERS_EDIT';
export type UPDATE_RECOMMENDATIONS_FOR_BANNERS_EDIT = typeof UPDATE_RECOMMENDATIONS_FOR_BANNERS_EDIT;

export interface UpdateRecommendationsForBannersEditAction {
    type: UPDATE_RECOMMENDATIONS_FOR_BANNERS_EDIT;
    recommendations: Record<string, EditPageRecommendationsData>;
}

export function updateRecommendationsForBannersEdit(
    recommendations: Record<string, EditPageRecommendationsData>
): UpdateRecommendationsForBannersEditAction {
    return {
        type: UPDATE_RECOMMENDATIONS_FOR_BANNERS_EDIT,
        recommendations
    };
}

export const FETCH_RECOMMENDATIONS_FOR_BANNERS_EDIT =
    'FETCH_RECOMMENDATIONS_FOR_BANNERS_EDIT';
export type FETCH_RECOMMENDATIONS_FOR_BANNERS_EDIT = typeof FETCH_RECOMMENDATIONS_FOR_BANNERS_EDIT;

export interface FetchRecommendationsForBannersEditAction {
    type: FETCH_RECOMMENDATIONS_FOR_BANNERS_EDIT;
    login: string;
    groupIds: Array<string>;
    campainIds: Array<string>;
}

export function fetchRecommendationsForBannersEdit(
    login: string,
    campainIds: Array<string>,
    groupIds: Array<string>
): FetchRecommendationsForBannersEditAction {
    return {
        type: FETCH_RECOMMENDATIONS_FOR_BANNERS_EDIT,
        login,
        groupIds,
        campainIds
    };
}

export const CLOSE_RECOMMENDATIONS_FOR_BANNERS_EDIT =
    'CLOSE_RECOMMENDATIONS_FOR_BANNERS_EDIT';
export type CLOSE_RECOMMENDATIONS_FOR_BANNERS_EDIT = typeof CLOSE_RECOMMENDATIONS_FOR_BANNERS_EDIT;

export interface CloseRecommendationsForBannersEditAction {
    type: CLOSE_RECOMMENDATIONS_FOR_BANNERS_EDIT;
    id: string;
}

export function onCloseRecommendationsForBannersEdit(
    id: string
): CloseRecommendationsForBannersEditAction {
    return {
        type: CLOSE_RECOMMENDATIONS_FOR_BANNERS_EDIT,
        id
    };
}

export const OPEN_RECOMMENDATIONS_MODAL_FOR_BANNERS_EDIT =
    'OPEN_RECOMMENDATIONS_MODAL_FOR_BANNERS_EDIT';
export type OPEN_RECOMMENDATIONS_MODAL_FOR_BANNERS_EDIT = typeof OPEN_RECOMMENDATIONS_MODAL_FOR_BANNERS_EDIT;

export interface OpenRecommendationsModalForBannersEditAction {
    type: OPEN_RECOMMENDATIONS_MODAL_FOR_BANNERS_EDIT;
    id: string;
}

export function openRecommendationsModalForBannersEdit(
    id: string
): OpenRecommendationsModalForBannersEditAction {
    return {
        type: OPEN_RECOMMENDATIONS_MODAL_FOR_BANNERS_EDIT,
        id
    };
}

export type BannersEditRecommendationsAction =
    | UpdateRecommendationsForBannersEditAction
    | CloseRecommendationsForBannersEditAction
    | OpenRecommendationsModalForBannersEditAction
    | FetchRecommendationsForBannersEditAction;
